import AuthStore from './auth';
import NotificationsStore from './notifications';

export const RootStore = {
	auth: AuthStore,
	notif: NotificationsStore,
};

export const useStore = () => RootStore;
